<template>
  <div style="height:100%">
    <div class="main">
      <div class="header">
        <a-button @click="openConfig" type="primary">{{
          $t("page_workstation_maintain_config")
        }}</a-button>
        <div>
          <a-button @click="searchForm">{{
            $t("page_my_document_advanced")
          }}</a-button>
        </div>
      </div>
      <div class="body">
        <ml-table
          :columns="columns"
          :dataSource="data"
          :canChangeColWidth="true"
          :scroll="{ x: 500, y: 500 }"
          rowKey="id"
          :custom-row="rowClick"

        >
          <template slot="maintenance" slot-scope="text, record">
            <a v-if="record.id" @click="openEdit(record)">{{ $t("edit") }}</a>
            <a-popconfirm
              :title="$t('delete_tips')"
              ok-text="Yes"
              cancel-text="No"
              @confirm="delect(record)"
              @cancel="cancel"
            >
              <a v-if="record.id" style="color:red;margin-left:8px">{{ $t("delete") }}</a>
            </a-popconfirm>
          </template>
        </ml-table>
        <a-pagination
        style="float:right;margin-top:20px;margin-right:20px;"
        :total="pagination.total"
        :showTotal="total => `${totalFanyi(total)}`"
        :pageSize="pagination.pageSize"
        :current="pagination.current"
        @change="pageIndexchange"
      ></a-pagination>
      </div>
    </div>
    <a-modal
      :title="modalTitle"
      :visible="ConfigVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div>
        <a-form-model
          ref="ruleForm"
          :model="configList"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :rules="rules"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_notification_model_name') + ':'"
                prop="name"
              >
                <a-input
                  v-model="configList.name"
                  :placeholder="$t('common_please_input') + $t('page_console_notification_model_name')"
                  :disabled="type === 'edit'"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_notification_type') + ':'"
                prop="type"
              >
                <a-select
                  show-search
                  :filter-option="filterOption"
                  v-model="configList.type"
                  :placeholder="$t('please_select') + $t('page_console_notification_type')"
                  :disabled="type === 'edit'"
                  @change="changeType"
                >
                  <a-select-option
                    v-for="(item, index) in typesList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_service_provider') + ':'"
                prop="provider"
              >
                <a-select
                  show-search
                  :filter-option="filterOption"
                  v-model="configList.provider"
                  :placeholder="$t('please_select') + $t('page_console_service_provider')"
                  :disabled="type === 'edit'"
                  @change="changeProvider"
                >
                  <a-select-option
                    v-for="(item, index) in providers"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_notification_business') + ':'"
                prop="business"
              >
                <a-select
                  show-search
                  :filter-option="filterOption"
                  v-model="configList.business"
                  :placeholder="$t('please_select') + $t('page_console_notification_business')"
                  :disabled="type === 'edit'"
                >
                  <a-select-option
                    v-for="(item, index) in dictList"
                    :key="index"
                    :value="item.dictKey"
                  >
                    {{ item.dictValue }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="model">
        <div>
          <div>
            <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-row v-for="(item, index) in modelList" :key="index">
                <a-col :span="24">
                  <a-form-model-item :label="item.name + ':'">
                    <a-input
                      v-model="item.value"
                      :placeholder="$t('common_please_input') + item.name"
                      v-if="
                        item.property === 'attachments' ||
                        item.property === 'properties' ||
                        item.property === 'content'
                          ? false
                          : true
                      "
                    />
                    <Other  v-if="item.property === 'properties'"
                      :placeholder="$t('common_please_input') + item.name"
                      :modelList="modelList"
                      @change="changeValue" /> 
                    <a-upload
                      name="file"
                      :multiple="true"
                      :customRequest="(e) => handleChangefileName(e, index)"
                      v-if="item.property === 'attachments' ? true : false"
                      @change="handleChange"
                      :file-list="fileList"
                    >
                      <a-button> <a-icon type="upload" /> 上传附件 </a-button>
                    </a-upload>
                    <editor-bar v-model="item.value" :isClear="isClear" v-if="item.property === 'content' ? true : false"></editor-bar>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </div>
      </div>
    </a-modal>
    <dragModal
      :title="$t('page_my_document_advanced')"
      :subTitle="`(${$t('page_console_notification_template')})`"
      :visible="searchVisible"
      top="140px"
      @ok="searchOk"
      @close="searchCancel"
    >
      <a-form-model
        ref="ruleForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item
          :label="$t('page_console_notification_model_name') + ':'"
        >
          <a-input
            v-model="searchList.name"
            :placeholder="$t('common_please_input') + $t('page_console_notification_model_name')"
          /> </a-form-model-item
        ><a-form-model-item :label="$t('page_console_notification_type') + ':'">
          <a-select
            show-search
            :filter-option="filterOption"
            v-model="searchList.type"
            :placeholder="$t('please_select') + $t('page_console_notification_type')"
            @change="changeType"
          >
            <a-select-option
              v-for="(item, index) in typesList"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select></a-form-model-item
        ><a-form-model-item :label="$t('page_console_service_provider') + ':'">
          <a-select
            show-search
            :filter-option="filterOption"
            v-model="searchList.provider"
            :placeholder="$t('please_select') + $t('page_console_service_provider')"
          >
            <a-select-option
              v-for="(item, index) in providers"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :label="$t('page_console_notification_business') + ':'"
        >
          <a-select
            show-search
            :filter-option="filterOption"
            v-model="searchList.business"
            :placeholder="$t('please_select') + $t('page_console_notification_business')"
          >
            <a-select-option
              v-for="(item, index) in dictList"
              :key="index"
              :value="item.dictKey"
            >
              {{ item.dictValue }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div style="text-align:center;padding-bottom:10px;" slot="footer">
        <a-button @click="searchOk" type="primary">{{$t('common_search')}}</a-button>
        <a-button @click="onSearchReset" style="margin-left: 10px;" type="default">{{
          $t('common_reset')
        }}</a-button>
      </div>
    </dragModal>
  </div>
</template>

<script>
import {
  NotifierTemplateServiceProxy,
  NotifierConfigServiceProxy,
} from "@/service-proxies/app-v2/notify.service-proxies";
import { DictServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import EditorBar from './wangEnduit.vue'
import Other from './components/ohter.vue'
import { putFilePOST, notifierTemplate } from "@/api/api";
const notifierTemplateServiceProxy = new NotifierTemplateServiceProxy();
const notifierConfigServiceProxy = new NotifierConfigServiceProxy();
const dictServiceProxy = new DictServiceProxy();
export default {
  components: {
    EditorBar,
    Other
  },
  data() {
    return {
      ConfigVisible: false,
      searchVisible: false,
      keyWords: "",
      data: [],
      selectedRowKeys: [],
      typesList: [],
      providers: [],
      modelList: [],
      dictList: [],
      fileList: [],
      id: "",
      isClear: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      type: "add",
      pagination: {
        total: 0,
        pageSize: 30,
        current: 1,
      },
      configList: {
        type: undefined,
        name: undefined,
        provider: undefined,
        business: undefined
      },
      searchList: {
        type: undefined,
        name: undefined,
        provider: undefined,
        business: undefined
      },
      headers: {
        authorization: "authorization-text",
      },
      rules: {
        name: [{ required: true, message: "请输入值", trigger: "blur" }],
        type: [{ required: true, message: "请选择值", trigger: "blur" }],
        provider: [{ required: true, message: "请选择值", trigger: "blur" }],
        business: [{ required: true, message: "请选择值", trigger: "blur" }],
      },
    };
  },
  created() {
    this.configPageList();
  },
  watch: {
    ConfigVisible: {
      handler(val) {
        if (val) {
          this.getAllNotifyTypes();
          this.dictionary();
        } else {
          this.fileList = [];
        }
      },
    },
    "configList.type": {
      handler(val) {
        if (val) {
          this.getTypeProviders(val);
        }
      },
    },
    searchVisible: {
      handler(val) {
        if (!val) {
          // this.searchList.name = "";
          // this.searchList.type = "";
          // this.searchList.provider = "";
          // this.searchList.business = "";
        } else {
          this.getAllNotifyTypes();
          this.dictionary();
        }
      },
    },
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("actions"),
          dataIndex: "maintenance",
          ellipsis: true,
          width: 40,
          scopedSlots: { customRender: "maintenance" },
        },
        // {
        //   title: this.$t("模板编码"),
        //   dataIndex: "id",
        //   ellipsis: true,
        //   width: 80,
        // },
        {
          title: this.$t("page_console_notification_model_name"),
          dataIndex: "name",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_console_notification_type"),
          dataIndex: "type",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_console_notification_business"),
          dataIndex: "business",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_console_service_provider"),
          dataIndex: "provider",
          ellipsis: true,
          width: 80,
        },
      ];
    },
    modalTitle() {
      return this.type === "edit"
        ? this.$t("edit")
        : this.$t("page_workstation_maintain_config");
    },
  },
  methods: {
    getCheckboxProps(record) {
      return ({
        style: {
          display: record.id ? 'block' : 'none'
        },
        props: {
          disabled: record.id ? false: true
        }
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    changeValue(val) {
      this.properties = val;
    },
    pageIndexchange(currentPage) {
      this.pagination.current = currentPage;
      this.configPageList();
    },
    totalFanyi(number) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    async configPageList() {
      let res = await notifierTemplateServiceProxy.configPageList(
        this.searchList.business,
        this.pagination.current,
        this.searchList.name,
        this.searchList.provider,
        this.pagination.pageSize,
        this.searchList.type,
      );
      this.pagination.total = res.total;
      // this.data = res.records;

      let dataLength = res.records.length;
      let copy = JSON.parse(JSON.stringify(res.records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {  
            // id: 'none'
          }
          copy.push(obj)  
        }
      }
      this.data = JSON.parse(JSON.stringify(copy));

    },
    async getAllNotifyTypes() {
      let res = await notifierConfigServiceProxy.getAllNotifyTypes();
      this.typesList = res;
      console.log(res, 55);
    },
    async getTypeProviders(val) {
      let res = await notifierConfigServiceProxy.getTypeProviders(val);
      this.providers = res;
    },
    async detail(id) {
      let res = await notifierTemplateServiceProxy.detail(id);
      this.configList.code = res.id;
      this.configList.name = res.name;
      this.configList.provider = res.provider;
      this.configList.type = res.type;
      this.configList.business = res.business;
      let obj = JSON.parse(res.template);
      this.modelList = [];
      const {data: {data: result} } = await notifierTemplate({provider: res.type, type: res.provider});
      if (result.properties && result.properties.length > 0) {
        result.properties.map((item) => {
          const {type: {type,properties}} = item;
          if(type==='object') {
            for(let i = 0 ; i<properties.length; i++) {
              const _item = properties[i];
              this.modelList.push({name: _item['name'], value: obj[item.property][_item.id], property: _item.id , parentProperty: item.property});
            }
          } else{
            this.modelList.push(
                Object.assign({}, item, {
                  value: obj[item.property],
                })
            );
          }
        });
      }
      this.modelList.map((item) => {
        if (item.property === "attachments") {
          this.fileList = [...item.value];
        }
      });
      console.log(6666, this.modelList);
    },
    async remove(id) {
      await notifierTemplateServiceProxy.remove(id).then((res) => {
        this.$message.success("删除成功");
        this.configPageList();
      });
    },
    async getModel(provider, type) {
      this.modelList = [];
      const {data: {data: res} } = await notifierTemplate({provider, type});
      if (res.properties && res.properties.length > 0) {
        res.properties.map((item) => {

          const {type: {type,properties}} = item;
          if(type==='object') {
            for(let i = 0 ; i<properties.length; i++) {
              const _item = properties[i];
              this.modelList.push({name: _item['name'], value: '', property: _item.id , parentProperty: item.property});
            }
          } else{
            this.modelList.push(
                Object.assign({}, item, {
                  value: "",
                })
            );
          }
        });
      }
    },
    async dictionary() {
      let res = await dictServiceProxy.dictionary("notify-biz-key");
      this.dictList = res.data;
    },
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let obj = {};
          // let a = {}
          let mini = {};
          this.modelList.map((item) => {
            // console.log(6666,this.modelList)
            // if(item.property === "content") {
            //    item.value = "<div style=\'width:50%;margin:0 auto\'>"+item.value+"</div>"
            // }
            if(item.hasOwnProperty('parentProperty')) {
              mini[item.property] = item.value;
            } else {
              this.$set(obj, item.property, item.value);
            }
          });
          // obj = JSON.parse(JSON.stringify(a))
          // obj.content = "<div style=\'width:50%;margin:0 auto\'>"+obj.content+"</div>"
          // console.log(1,obj)
          this.$set(obj, "attachments", this.fileList);
          this.$set(obj, 'miniProgram', mini);
          if (this.type === "add") {
            var param = {
              business: this.configList.business,
              name: this.configList.name,
              provider: this.configList.provider,
              template: JSON.stringify(obj),
              type: this.configList.type,
            };
          } else {
            var param = {
              business: this.configList.business,
              id: this.id,
              name: this.configList.name,
              provider: this.configList.provider,
              template: JSON.stringify(obj),
              type: this.configList.type,
            };
          }
          await notifierTemplateServiceProxy.submit(param).then((res) => {
            this.configPageList();
            this.$message.success("操作成功");
            this.$refs.ruleForm.resetFields();
            this.ConfigVisible = false;
          });
        }
      });
    },
    openConfig() {
      this.modelList = [];
      this.type = "add";
      this.ConfigVisible = true;
    },
    handleOk() {
      this.submit();
    },
    handleCancel() {
      this.$refs.ruleForm.resetFields();
      this.ConfigVisible = false;
    },
    searchForm() {
      this.searchVisible = !this.searchVisible;
    },
    openEdit(val) {
      this.detail(val.id);
      this.id = val.id;
      this.type = "edit";
      this.ConfigVisible = true;
      console.log(888);
    },
    delect(val) {
      this.remove(val.id);
      console.log(777);
    },
    onSelect(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    changeType(val) {
      this.modelList = [];
      this.configList.provider = undefined
      this.searchList.provider = undefined
      this.getTypeProviders(val);
      console.log(888);
    },
    changeProvider(val) {
      this.getModel(this.configList.type, val);
    },
    cancel(e) {
      console.log(e);
    },
    handleChangefileName(file, index) {
      const formData = new FormData();
      formData.append("file", file.file);
      putFilePOST(formData).then((res) => {
        if (res.data.data) {
          const tempFile = {};
          tempFile.location = res.data.data.link;
          tempFile.name = res.data.data.originalName;
          tempFile.uid = res.data.data.name;
          this.modelList.map((item) => {
            if (item.property === "attachments") {
              this.fileList = [...item.value];
            }
          });
          this.fileList.push(tempFile);
        }
        console.log(8888, this.fileList);
      });
    },
    handleChange(val) {
      this.modelList.map((item) => {
        if (item.property === "attachments") {
          this.fileList = [...item.value];
        }
      });
      const list = this.fileList.filter((e) => e.uid !== val.file.uid);
      console.log(666, val);
      this.fileList = [...list];
      console.log(9999, list);
    },
    searchOk() {
      this.configPageList();
      // this.searchVisible = false;
    },
    searchCancel() {
      this.searchVisible = false;
    },
    onSearchReset(){
      this.searchList.name = undefined
      this.searchList.type = undefined
      this.searchList.provider = undefined
      this.searchList.business = undefined
    },
    rowClick(record) {
      return {
        on: {
          click: (event) => {
            this.selectedRowKeys = [];
            this.selectedRowKeys.push(record.id);
          },
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  width: 100%;
  background-color: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    padding: 18px 0px;
  }
}
.model {
  width: 100%;
}
/deep/ .ant-row .ant-form-item {
  display: flex;
}
.ant-form-item {
  margin-bottom: 10px !important;
}
/deep/ .ant-modal-content {
  width: 1000px;
  margin-left: -100px;
}
/deep/ .ql-picker-label {
  display: flex;
}
</style>
